"use client";

import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
import { useState, useLayoutEffect } from "react";
import { useSelectedLayoutSegment } from "next/navigation";
import GetInTouchButton from "@/components/ui/GetInTouchButton";
import useFramerMotion, { LazyMotion, m } from "@/hooks/useFramerMotion";
import { Pathnames } from "@/i18n/routing";
import { Link } from "@/components/Link";
import { useTranslations, useLocale } from "next-intl";
import LanguageSwitcher from "./LanguageSwitcher";
import { useBreakpoint } from "@/hooks/useBreakpoint";
import ChangeHologram from "../ui/ChangeHologram";
const NavMobile = dynamic(() => import("./NavMobile"));
export const routes: {
  path: Pathnames;
  key: string;
  hologram: number;
}[] = [{
  key: "portfolio",
  path: "/",
  hologram: 3
}, {
  key: "clients",
  path: "/clients",
  hologram: 2
}, {
  key: "about",
  path: "/about",
  hologram: 5
}, {
  key: "contact",
  path: "/contact",
  hologram: 4
}];
const Nav = () => {
  const $ = _c(22);
  const {
    maxXl
  } = useBreakpoint();
  const framerMotionFeatures = useFramerMotion();
  const selectedLayoutSegment = useSelectedLayoutSegment();
  const pathname = selectedLayoutSegment ? `/${selectedLayoutSegment}` : "/";
  const [mobileNavVisible, setMobileNavVisible] = useState(true);
  const locale = useLocale();
  const t = useTranslations("nav");
  let t0;
  let t1;
  if ($[0] !== maxXl) {
    t0 = () => {
      setMobileNavVisible(maxXl);
    };
    t1 = [maxXl];
    $[0] = maxXl;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useLayoutEffect(t0, t1);
  let t2;
  if ($[3] !== t) {
    t2 = t("desktopLabel");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== locale || $[6] !== pathname || $[7] !== t) {
    t3 = routes.map(item => {
      const isActive = pathname === item.path;
      return <ChangeHologram hologram={item.hologram} key={item.key}><Link href={item.path} locale={locale} className={`${isActive ? "text-mint" : ""} relative font-secondary font-medium tracking-wide transition-all hover:text-mint`}>{t(item.key)}{isActive && <m.div layoutId="activeItem" transition={{
            type: "spring",
            bounce: 0.3,
            duration: 0.6
          }} className="absolute -bottom-0.5 h-[2px] w-full bg-mint" />}</Link></ChangeHologram>;
    });
    $[5] = locale;
    $[6] = pathname;
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <nav aria-label={t2} className="items-center gap-8 xl:flex">{t3}</nav>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <GetInTouchButton />;
    t6 = <LanguageSwitcher />;
    $[12] = t5;
    $[13] = t6;
  } else {
    t5 = $[12];
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4) {
    t7 = <div className="items-center gap-8 max-xl:hidden xl:flex">{t4}{t5}{t6}</div>;
    $[14] = t4;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== mobileNavVisible) {
    t8 = mobileNavVisible && <NavMobile />;
    $[16] = mobileNavVisible;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== framerMotionFeatures || $[19] !== t7 || $[20] !== t8) {
    t9 = <><LazyMotion features={framerMotionFeatures}>{t7}{t8}</LazyMotion></>;
    $[18] = framerMotionFeatures;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};
export default Nav;